import { createContext, useContext } from "react";
import { Event } from "../../models/calendar/Event.model";




export const EventsContext = createContext<{ events: Event[]; setEvents: React.Dispatch<React.SetStateAction<Event[]>> } | undefined>(undefined);

export const useEvents = () => {
  const context = useContext(EventsContext);
  if (!context) {
    throw new Error('useEvents must be used within a EventsContext.provider');
  }
  return context;
};